var map = {
	"./logo-ucentralcolombia.svg": 1181,
	"./logo-uplanner.svg": 1182
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1180;



//////////////////
// WEBPACK FOOTER
// ./src/assets/images ^\.\/logo\-.*\.svg$
// module id = 1180
// module chunks = 0